import { Component, OnInit, Input } from '@angular/core';
import { EchantillonJury } from 'src/app/data/commission/models/echantillon-jury.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, UntypedFormArray, Validators, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-affectation-echantillons',
    templateUrl: './affectation-echantillons.component.html',
    styleUrls: ['./affectation-echantillons.component.scss'],
    standalone: false
})
export class AffectationEchantillonsComponent implements OnInit {
    constructor(private readonly modal: NgbActiveModal, private readonly fb: UntypedFormBuilder) {}
    @Input() echantillonsListe: EchantillonJury[];
    @Input() nbJurys: number;
    echantillons: EchantillonJury[];
    affectationsForm: UntypedFormGroup;
    echantillonsForms: { echantillon: EchantillonJury; form: UntypedFormGroup }[];

    // ###################################

    order = {
        property: 'id',
        reverse: false
    };

    ngOnInit() {
        this.echantillons = this.echantillonsListe; // .filter(e => e.echantillon);

        this.affectationsForm = this.fb.group({ liste: this.fb.array([]) });
        this.echantillonsForms = [];

        this.echantillons.forEach(echantillon => {
            const form = this.fb.group({
                echantillon: [echantillon.echantillon ? echantillon.echantillon.id : echantillon.leurre.id],
                jury: [echantillon.numeroJury, [Validators.required, this.juryValidator.bind(this)]],
                anonymat: [echantillon.numeroAnonymat]
            });

            this.echantillonsForms.push({ echantillon, form });
            (this.affectationsForm.get('liste') as UntypedFormArray).push(form);
        });
    }

    juryValidator(control: UntypedFormControl) {
        const v = control.value as number;
        if (v < 1 || v > this.nbJurys) {
            return { invalid: true };
        }
        return null;
    }

    cancel() {
        this.modal.dismiss();
    }

    submit() {
        if (this.affectationsForm.valid) {
            const result: { [name: number]: EchantillonJury[] } = {};

            this.echantillonsForms.forEach(f => {
                const jury = f.form.get('jury').value;
                const anonymat = f.form.get('anonymat').value;
                const ech = f.echantillon;

                if (result[jury] === undefined) {
                    result[jury] = [];
                }
                ech.numeroAnonymat = anonymat;
                result[jury].push(ech);
            });

            this.modal.close(result);
        }
    }

    setOrder(property: string) {
        if (property) {
            if (property === this.order.property) {
                this.order.reverse = !this.order.reverse;
            } else {
                this.order = {
                    property,
                    reverse: false
                };
            }
        }
    }

    getIcon(property: string) {
        if (property === this.order.property) {
            return this.order.reverse ? 'sort-down' : 'sort-up';
        } else {
            return 'sort';
        }
    }

    numeroter() {
        let numero = 1;
        for (let i = 0; i < this.nbJurys; i++) {
            this.echantillonsForms.forEach(f => {
                if (f.form.get('jury').value === i + 1) {
                    f.echantillon.numeroAnonymat = (numero++).toString();
                    f.form.get('anonymat').patchValue(f.echantillon.numeroAnonymat);
                    f.form.get('anonymat').updateValueAndValidity();
                }
            });
        }
    }
}
